"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var index_1 = require("../index");
function default_1(row, isLastRow, classes) {
    var longestArrayValueLength = Math.max.apply(Math, row.cells.map(function (cell) { var _a; return (Array.isArray(cell.value) && ((_a = cell.value) === null || _a === void 0 ? void 0 : _a.length)) || 1; }));
    var rowChildren = Array.from({ length: longestArrayValueLength }, function () { return []; });
    row.cells.forEach(function (cell) {
        var _a;
        var cellRenderer = cell.column.Cell
            ? cell.column.Cell
            : function (x) { return (react_1.default.createElement(index_1.Typography, { variant: 'textMedium' }, x.value)); };
        if (Array.isArray(cell.value)) {
            cell.value.forEach(function (value, i) {
                var _a;
                return rowChildren[i].push(react_1.default.createElement("td", { key: "".concat(cell.getCellProps().key, "-i"), className: (0, classnames_1.default)(classes.cell, (_a = {},
                        _a[classes.hideBottomBorder] = isLastRow && i === rowChildren.length - 1,
                        _a)) }, cellRenderer({ value: value, rowData: row.original })));
            });
        }
        else {
            rowChildren[0].push(react_1.default.createElement("td", { key: cell.getCellProps().key, className: (0, classnames_1.default)(classes.cell, (_a = {},
                    _a[classes.hideBottomBorder] = isLastRow,
                    _a)), rowSpan: longestArrayValueLength }, cellRenderer({ value: cell.value, rowData: row.original })));
        }
    });
    return rowChildren.map(function (children, i) { return (react_1.default.createElement("tr", __assign({}, row.getRowProps(), { key: "".concat(row.getRowProps().key, "-").concat(i), className: classes.row }), children)); });
}
exports.default = default_1;
//# sourceMappingURL=createSubRows.js.map